import { PlaceholderPage } from './PlaceholderPage';

export const GeneralParametersPage = () => <PlaceholderPage title="General Parameters" />;
